import MediaPublishSetting from '../views/Data/MediaPublishSetting';

let Third = [
  {
    path: 'MediaPublishSetting',
    name: '媒体发布',
    component: MediaPublishSetting
  }
];

export default Third;
